import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyC2gns7qXEUab8EUebVIaBnxIplLTvl3PA",
  authDomain: "argardenunity.firebaseapp.com",
  databaseURL: "https://argardenunity-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "argardenunity",
  storageBucket: "argardenunity.appspot.com",
  messagingSenderId: "691562841291",
  appId: "1:691562841291:web:797f9811fa7d2c5adec74e",
  measurementId: "G-P14FZZERHK",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
// Functions are deployed to europe-central2 (the default us-central1 returns 404).
export const functions = getFunctions(app, "europe-central2");
export default app;
